(function () {
  var TIMER_MINUTES = 7;
  var TIMER_KEY = 'ccd_timer_expires';
  var FREE_SHIPPING_THRESHOLD_CENTS = 1499;

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  var overlay = document.getElementById('ccd-overlay');
  var drawer = document.getElementById('ccd-drawer');
  var itemsEl = document.getElementById('ccd-items');
  var emptyEl = document.getElementById('ccd-empty');
  var headerCount = document.getElementById('ccd-header-count');
  var timerBanner = document.getElementById('ccd-timer-banner');
  var timerValue = document.getElementById('ccd-timer-value');
  var shippingBar = document.getElementById('ccd-shipping-bar');
  var shippingFill = document.getElementById('ccd-shipping-fill');
  var checkoutBtn = document.getElementById('ccd-checkout');
  var csCards = document.getElementById('ccd-cs-cards');
  var csLeft = document.getElementById('ccd-cs-arrow-left');
  var csRight = document.getElementById('ccd-cs-arrow-right');
  var stickyBtn = document.getElementById('ccd-sticky');
  var stickyBadge = document.getElementById('ccd-sticky-badge');

  var crossSellProducts = window.ccdCrossSellProducts || [];
  var timerInterval = null;
  var csIndex = 0;
  var requestSeq = 0;

  function nextRequestId() {
    requestSeq += 1;
    return requestSeq;
  }
  function isLatest(id) {
    return id === requestSeq;
  }

  function openDrawer() {
    overlay.classList.add('ccd-open');
    drawer.classList.add('ccd-open');
    drawer.style.transform = 'translateX(0)';
    document.body.style.overflow = 'hidden';
    stickyBtn.hidden = true;
  }
  function closeDrawer() {
    overlay.classList.remove('ccd-open');
    drawer.classList.remove('ccd-open');
    drawer.style.transform = 'translateX(100%)';
    document.body.style.overflow = '';
    stickyBtn.hidden = false;
  }

  function startTimer() {
    var expires = localStorage.getItem(TIMER_KEY);
    var now = Date.now();
    if (!expires || parseInt(expires, 10) < now) {
      expires = now + TIMER_MINUTES * 60 * 1000;
      localStorage.setItem(TIMER_KEY, expires);
    }
    if (timerInterval) clearInterval(timerInterval);
    function tick() {
      var remaining = Math.max(0, parseInt(localStorage.getItem(TIMER_KEY), 10) - Date.now());
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      timerValue.textContent = String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
      if (remaining <= 0) {
        clearInterval(timerInterval);
        localStorage.removeItem(TIMER_KEY);
      }
    }
    tick();
    timerInterval = setInterval(tick, 1000);
  }
  // Löscht die Reservierungs-Uhr nur, wenn der Warenkorb wirklich leer ist (dann startet der
  // nächste Kauf sauber bei 7:00). Ein bloßes Öffnen/Schließen des Drawers oder ein weiterer
  // Kauf im selben Warenkorb darf die bereits laufende Zeit NICHT zurücksetzen - startTimer()
  // läuft sonst einfach mit dem bestehenden, gespeicherten Ablaufzeitpunkt weiter.
  function clearTimerIfEmpty(cart) {
    if (cart && cart.item_count === 0) {
      localStorage.removeItem(TIMER_KEY);
      // Ohne dies läuft das Interval weiter, findet aber keinen gespeicherten Wert mehr
      // und rechnet mit NaN weiter (NaN <= 0 ist false, das Interval stoppt sich also nie
      // selbst) - Anzeige bleibt für immer bei "NaN:NaN" hängen.
      if (timerInterval) {
        clearInterval(timerInterval);
        timerInterval = null;
      }
      timerValue.textContent = String(TIMER_MINUTES).padStart(2, '0') + ':00';
    }
  }

  function renderShippingBar(cart) {
    var country = window.Shopify && window.Shopify.country;
    if (country !== 'DE') {
      shippingBar.hidden = true;
      return;
    }
    shippingBar.hidden = false;
    var remaining = FREE_SHIPPING_THRESHOLD_CENTS - cart.total_price;
    if (remaining > 0) {
      shippingBar.querySelector('p').textContent = 'Nur noch ' + formatMoney(remaining) + ' bis zum kostenlosen Versand!';
      var pct = Math.max(0, Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD_CENTS) * 100));
      shippingFill.style.width = pct + '%';
    } else {
      shippingBar.querySelector('p').textContent = 'Kostenloser Versand erreicht!';
      shippingFill.style.width = '100%';
    }
  }

  // Zuletzt tatsächlich angezeigter Preis/Anzahl - verhindert, dass eine Hintergrund-Abfrage
  // (pollUntilStable) den Preis kurzzeitig wieder auf einen noch nicht rabattierten
  // Zwischenstand zurückspringen lässt, bevor Shopify den Rabatt fertig berechnet hat.
  // Gilt sowohl für die Gesamtsumme als auch (pro Zeilen-Key) für die einzelne Artikelzeile.
  var ccdDisplayedCount = null;
  var ccdDisplayedTotal = null;
  var ccdDisplayedLinePrices = {};

  // knownGoodTotal: optionaler, bereits als korrekt bekannter Gesamtpreis. lineOverrides:
  // optionale { [item.key]: preis }-Zuordnung für einzelne Artikelzeilen - beides z.B.
  // optimistisch aus dem bekannten Bundle-Festpreis berechnet, überschreibt die Shopify-Werte
  // nur für die Anzeige - der nächste echte Cart-Fetch (pollUntilStable) gleicht ab.
  function renderCart(cart, knownGoodTotal, lineOverrides) {
    var displayTotal = (typeof knownGoodTotal === 'number') ? knownGoodTotal : cart.total_price;
    // Niemals bei gleicher Artikelzahl auf einen HÖHEREN (= noch unrabattierten) Preis
    // zurückspringen - nur Verbesserungen/Bestätigungen nach unten zulassen.
    if (ccdDisplayedCount === cart.item_count && ccdDisplayedTotal !== null && displayTotal > ccdDisplayedTotal) {
      displayTotal = ccdDisplayedTotal;
    }
    ccdDisplayedCount = cart.item_count;
    ccdDisplayedTotal = displayTotal;
    headerCount.textContent = cart.item_count;
    stickyBadge.textContent = cart.item_count;
    checkoutBtn.textContent = 'Zur Kasse • ' + formatMoney(displayTotal);
    checkoutBtn.disabled = cart.item_count === 0;

    if (cart.item_count === 0) {
      clearTimerIfEmpty(cart);
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
    } else {
      emptyEl.hidden = true;
      itemsEl.innerHTML = cart.items.map(function (item, idx) {
        var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        var linePrice = (lineOverrides && typeof lineOverrides[item.key] === 'number') ? lineOverrides[item.key] : item.final_line_price;
        if (ccdDisplayedLinePrices.hasOwnProperty(item.key) && linePrice > ccdDisplayedLinePrices[item.key]) {
          linePrice = ccdDisplayedLinePrices[item.key];
        }
        ccdDisplayedLinePrices[item.key] = linePrice;
        return (
          '<div class="ccd-item" data-line="' + (idx + 1) + '">' +
            '<img src="' + (item.image || '') + '" alt="' + escapeHtml(item.product_title) + '">' +
            '<div class="ccd-item-info">' +
              '<div class="ccd-item-top">' +
                '<div>' +
                  '<p class="ccd-item-title">' + escapeHtml(item.product_title) + '</p>' +
                  (variantLabel ? '<p class="ccd-item-variant">Farbe: ' + escapeHtml(variantLabel) + '</p>' : '<p class="ccd-item-variant"></p>') +
                '</div>' +
                '<button class="ccd-remove" data-action="remove" data-line="' + (idx + 1) + '" aria-label="Entfernen">✕</button>' +
              '</div>' +
              '<div class="ccd-item-bottom">' +
                '<div class="ccd-qty">' +
                  '<button data-action="dec" data-line="' + (idx + 1) + '">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button data-action="inc" data-line="' + (idx + 1) + '">+</button>' +
                '</div>' +
                '<span class="ccd-item-price">' + formatMoney(linePrice) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
    if (displayTotal !== cart.total_price) {
      var shippingCart = {};
      for (var k in cart) { shippingCart[k] = cart[k]; }
      shippingCart.total_price = displayTotal;
      renderShippingBar(shippingCart);
    } else {
      renderShippingBar(cart);
    }
    renderCrossSell(cart);
  }

  function goToSlide(index) {
    var max = csCards.children.length - 1;
    csIndex = Math.max(0, Math.min(index, max));
    csCards.style.transform = 'translateX(-' + (csIndex * 100) + '%)';
  }

  function renderCrossSell(cart) {
    var cartHandles = cart.items.map(function (i) { return i.handle; });
    var candidates = crossSellProducts.filter(function (p) { return cartHandles.indexOf(p.handle) === -1; });
    if (candidates.length === 0) candidates = crossSellProducts;

    csCards.innerHTML = candidates.map(function (p) {
      if (p.isBundle) {
        return (
          '<div class="ccd-cs-card" data-handle="' + p.handle + '">' +
            '<div class="ccd-cs-card-top">' +
              '<img class="ccd-cs-img" src="' + p.image + '" alt="' + escapeHtml(p.title) + '">' +
              '<div>' +
                '<p class="ccd-cs-card-title">' + escapeHtml(p.title) + '</p>' +
                '<p class="ccd-cs-card-price">' + formatMoney(p.price) + '</p>' +
              '</div>' +
            '</div>' +
            '<div class="ccd-cs-row ccd-cs-row--single">' +
              '<a class="ccd-cs-add ccd-cs-view" href="' + p.url + '">Ansehen</a>' +
            '</div>' +
          '</div>'
        );
      }
      var hasChoice = p.variants.length > 1;
      var selectHtml = '';
      if (hasChoice) {
        var options = p.variants.map(function (v) {
          var imgAttr = v.image ? (' data-image="' + v.image + '"') : '';
          return '<option value="' + v.id + '"' + imgAttr + (v.available ? '' : ' disabled') + '>' + escapeHtml(v.title) + (v.available ? '' : ' (ausverkauft)') + '</option>';
        }).join('');
        selectHtml = '<select class="ccd-cs-select">' + options + '</select>';
      }
      var soldOut = !hasChoice && !p.variants[0].available;
      return (
        '<div class="ccd-cs-card" data-handle="' + p.handle + '">' +
          '<div class="ccd-cs-card-top">' +
            '<img class="ccd-cs-img" src="' + p.image + '" alt="' + escapeHtml(p.title) + '">' +
            '<div>' +
              '<p class="ccd-cs-card-title">' + escapeHtml(p.title) + '</p>' +
              '<p class="ccd-cs-card-price">' + formatMoney(p.price) + '</p>' +
            '</div>' +
          '</div>' +
          '<div class="ccd-cs-row' + (hasChoice ? '' : ' ccd-cs-row--single') + '">' +
            selectHtml +
            '<button class="ccd-cs-add" data-action="cs-add" data-variant="' + (hasChoice ? '' : p.variants[0].id) + '"' + (soldOut ? ' disabled' : '') + '>' + (soldOut ? 'Ausverkauft' : 'Hinzufügen') + '</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');
    csIndex = 0;
    csCards.style.transform = 'translateX(0)';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function fetchCart() {
    // cache: 'no-store' + Zeitstempel erzwingen eine echte Server-Anfrage statt einer
    // zwischengespeicherten Antwort - sonst liefert schnelles Nachfragen (pollUntilStable)
    // immer wieder denselben (ggf. noch unrabattierten) alten Stand.
    return fetch('/cart.js?_=' + Date.now(), { __ccdInternal: true, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  // Zuletzt bekannter, GESICHERT korrekter Stand (vor der jeweils aktuellen Aktion) -
  // wird genutzt, um beim Hinzufügen eines Bundles sofort einen korrekten Gesamtpreis (und
  // die passenden Zeilenpreise) zu zeigen, statt auf Shopifys teils verzögerte
  // Rabattberechnung zu warten. Startet SYNCHRON mit dem von Liquid mitgelieferten Stand
  // (statt erst auf den ersten fetchCart() zu warten) - sonst könnte ein sehr schnelles erstes
  // Hinzufügen (z.B. direkt nach dem Laden) den Vergleich verpassen, weil ccdLastCount noch
  // null wäre, und der Drawer würde sich fälschlich nicht öffnen.
  var ccdLastCount = (typeof window.ccdInitialCartCount === 'number') ? window.ccdInitialCartCount : null;
  var ccdLastTotal = (typeof window.ccdInitialCartTotal === 'number') ? window.ccdInitialCartTotal : 0;
  var ccdLastKeys = {};
  function ccdSnapshot(cart) {
    ccdLastCount = cart.item_count;
    ccdLastTotal = cart.total_price;
    ccdLastKeys = {};
    cart.items.forEach(function (item) { ccdLastKeys[item.key] = true; });
  }
  fetchCart().then(ccdSnapshot);

  // Liefert { total, lines } - lines ordnet den NEU hinzugekommenen Zeilen (im Vergleich zum
  // letzten bekannten Stand) einen optimistischen, bereits korrekten Preis zu. Bei mehreren
  // neuen Zeilen (z.B. gemischte Farben) wird der bekannte Bundle-Preis proportional zu ihrem
  // unrabattierten Anteil aufgeteilt, bei genau einer neuen Zeile bekommt sie den vollen Preis.
  function optimisticBundleOverrides(cart) {
    if (!(window.ccdIsBundlePage && typeof window.ccdBundlePrice === 'number' &&
          ccdLastCount !== null && cart.item_count > ccdLastCount)) {
      return { total: cart.total_price, lines: {} };
    }
    var newItems = cart.items.filter(function (item) { return !ccdLastKeys[item.key]; });
    var lines = {};
    if (newItems.length === 1) {
      lines[newItems[0].key] = window.ccdBundlePrice;
    } else if (newItems.length > 1) {
      var rawSum = newItems.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
      var allocated = 0;
      newItems.forEach(function (item, idx) {
        var share;
        if (idx === newItems.length - 1) {
          share = window.ccdBundlePrice - allocated;
        } else {
          share = rawSum > 0 ? Math.round(window.ccdBundlePrice * (item.final_line_price / rawSum)) : 0;
          allocated += share;
        }
        lines[item.key] = share;
      });
    }
    return { total: ccdLastTotal + window.ccdBundlePrice, lines: lines };
  }

  // Passiv auf Warenkorb-Änderungen reagieren, die NICHT von diesem Script selbst ausgelöst wurden
  // (z.B. Fast Bundle's eigener Add-to-Cart-Call auf Bundle-Seiten) - verhindert doppeltes Hinzufügen,
  // indem wir hier NICHTS hinzufügen, sondern nur den Drawer öffnen/aktualisieren.
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var isInternal = init && init.__ccdInternal;
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    var isCartWrite = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
    var p = nativeFetch(input, init);
    if (isCartWrite && !isInternal) {
      p.then(function () {
        var reqId = nextRequestId();
        fetchCart().then(function (cart) {
          if (!isLatest(reqId)) return;
          // Nur öffnen, wenn wirklich etwas HINZUGEFÜGT wurde (Artikelzahl gestiegen).
          // Andere Skripte (z.B. Klaviyo-Tracking, Länder-/Währungserkennung) rufen teils
          // beim allerersten Seitenaufruf (neue Sitzung, noch kein Warenkorb-Cookie) ebenfalls
          // /cart/update.js oder /cart/change.js auf, ohne dass ein Artikel dazukommt - das
          // darf den Drawer nicht ungefragt öffnen.
          var wasAdd = ccdLastCount !== null && cart.item_count > ccdLastCount;
          var optimistic = optimisticBundleOverrides(cart);
          renderCart(cart, optimistic.total, optimistic.lines);
          ccdSnapshot(cart);
          if (wasAdd) {
            openDrawer();
            startTimer();
            pollUntilStable();
          }
        });
      }).catch(function () {});
    }
    return p;
  };

  // Der Bundle-Rabatt (Shopify Function) wird teils erst mit spürbarer Verzögerung nach dem
  // Hinzufügen final berechnet - ein sofortiger Cart-Fetch kann noch minutenlang den
  // unrabattierten Preis liefern, und dieser falsche Preis bleibt dabei über mehrere Abfragen
  // hinweg "stabil" (ändert sich nicht), bevor er sich dann doch noch korrigiert. Ein Abbruch
  // bei gleichbleibendem Wert wäre also ein Trugschluss. Stattdessen: festes Zeitschema über
  // ca. 15s, das IMMER bis zum Ende durchläuft (re-rendert jedes Mal, harmlos da nur ein
  // schneller GET-Request) - dient nur noch als Absicherung/Bestätigung, da der Preis dank
  // optimisticBundleOverrides() schon sofort beim ersten Rendern korrekt angezeigt wird.
  var CCD_RESYNC_SCHEDULE = [300, 600, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 6500, 8000, 10000, 12500, 15000];
  function pollUntilStable() {
    CCD_RESYNC_SCHEDULE.forEach(function (delay) {
      setTimeout(function () {
        fetchCart().then(function (cart) { renderCart(cart); });
      }, delay);
    });
  }

  // Zusätzlicher Fallback für Bundle-Seiten: Fast Bundle nutzt teils eine eigene, früh
  // eingefangene fetch-Referenz, sodass der fetch-Wrapper oben sie nicht immer erwischt.
  // Deshalb zusätzlich: nach jedem Klick auf der Seite im schnellen Takt die Warenkorbmenge
  // prüfen und bei Erhöhung sofort den Drawer öffnen (rein lesend, fügt selbst nichts hinzu).
  if (window.ccdIsBundlePage) {
    document.addEventListener('click', function () {
      var tries = 0;
      (function detect() {
        tries++;
        setTimeout(function () {
          fetchCart().then(function (cart) {
            if (ccdLastCount !== null && cart.item_count > ccdLastCount) {
              var optimistic = optimisticBundleOverrides(cart);
              ccdSnapshot(cart);
              renderCart(cart, optimistic.total, optimistic.lines);
              openDrawer();
              startTimer();
              pollUntilStable();
            } else {
              ccdSnapshot(cart);
              if (tries < 15) detect();
            }
          });
        }, 200);
      })();
    }, true);
  }

  function refreshAndOpen() {
    var reqId = nextRequestId();
    fetchCart().then(function (cart) {
      if (!isLatest(reqId)) return;
      renderCart(cart); openDrawer(); startTimer();
    });
  }

  function changeLine(line, quantity) {
    var reqId = nextRequestId();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
      __ccdInternal: true
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!isLatest(reqId)) return;
      renderCart(cart);
    });
  }

  function addVariant(variantId) {
    var reqId = nextRequestId();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      __ccdInternal: true
    }).then(function () { return fetchCart(); }).then(function (cart) {
      if (!isLatest(reqId)) return;
      renderCart(cart); startTimer();
    });
  }

  // Item quantity / remove handlers
  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-action]');
    if (!btn) return;
    var line = parseInt(btn.dataset.line, 10);
    if (btn.dataset.action === 'remove') { changeLine(line, 0); return; }
    var currentSpan = btn.parentElement.querySelector('span');
    var current = parseInt(currentSpan.textContent, 10);
    if (btn.dataset.action === 'inc') changeLine(line, current + 1);
    if (btn.dataset.action === 'dec') changeLine(line, Math.max(0, current - 1));
  });

  // Cross-sell add handlers
  csCards.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-action="cs-add"]');
    if (!btn || btn.disabled) return;
    var card = btn.closest('.ccd-cs-card');
    var select = card.querySelector('select');
    var variantId = select ? select.value : btn.dataset.variant;
    if (!variantId) return;
    btn.disabled = true;
    addVariant(variantId).then(function () { btn.disabled = false; });
  });

  // Bild wechselt mit der Farbauswahl im Cross-Sell-Karussell (analog zur Produktseite) -
  // das <option>-Element trägt das passende Vorschaubild als data-image, damit hier keine
  // erneute Suche im crossSellProducts-Array nötig ist.
  csCards.addEventListener('change', function (e) {
    var select = e.target.closest('.ccd-cs-select');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var newSrc = opt && opt.dataset.image;
    if (!newSrc) return;
    var card = select.closest('.ccd-cs-card');
    var img = card && card.querySelector('.ccd-cs-img');
    if (img) img.src = newSrc;
  });

  csLeft.addEventListener('click', function () { goToSlide(csIndex - 1); });
  csRight.addEventListener('click', function () { goToSlide(csIndex + 1); });

  document.getElementById('ccd-close').addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  checkoutBtn.addEventListener('click', function () {
    if (!checkoutBtn.disabled) window.location.href = '/checkout';
  });
  stickyBtn.addEventListener('click', refreshAndOpen);

  // Initialize sticky badge on load
  (function () {
    var reqId = nextRequestId();
    fetchCart().then(function (cart) {
      stickyBadge.textContent = cart.item_count;
      if (isLatest(reqId)) headerCount.textContent = cart.item_count;
    });
  })();

  // Intercept all "open cart" triggers (cart icon, /cart links) - capture phase so we win over other handlers
  var cartTriggerSelectors = [
    'a[href="/cart"]', 'a[href*="/cart"]', '#cart-icon-bubble', '.header__icon--cart',
    '.site-header__cart', '.cart-link', '.js-cart-toggle', '.cart-toggle',
    '[data-cart-trigger]', '[data-action="open-cart"]', '[aria-label*="Warenkorb"]', '[aria-label*="Cart"]'
  ].join(',');

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(cartTriggerSelectors);
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      refreshAndOpen();
    }
  }, true);

  // Intercept "Add to cart" form submissions site-wide
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    // Auf Bundle-Seiten übernimmt Fast Bundle selbst den Add-to-Cart-Call (eigene Farb-/Varianten-Auswahl).
    // Wir greifen hier NICHT ein, sonst wird doppelt hinzugefügt. Der globale fetch-Wrapper oben
    // erkennt Fast Bundle's eigenen Call passiv und öffnet den Drawer.
    if (window.ccdIsBundlePage) return;
    e.preventDefault();
    var reqId = nextRequestId();
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData, __ccdInternal: true })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        if (!isLatest(reqId)) return;
        renderCart(cart); openDrawer(); startTimer();
      })
      .catch(function (err) { console.error('Custom Cart Drawer: add to cart failed', err); });
  }, true);

  // Expose for manual testing
  window.CustomCartDrawer = { open: refreshAndOpen, close: closeDrawer };
})();
